import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import Input from "../../../../../components/Form/Input/input";
import { Form, FormGroup } from "../../../../../components/Form/styles";
import { ImageField, LANDSCAPE_CROP } from "../../../../../components/ImageField";
import { Box } from "../../../../../components/Layout";
import SaveBar from "../../../../../components/SaveBar";
import { SectionHelp } from "../../../../../components/SectionHelp";
import { SubHeader } from "../../../../../components/SubHeader";
import { MediaSection } from "../../../../../model/site";
import { useSection } from "../../../hooks/Section";
import { Container } from "./styles";

export const ImageMediaPage = () => {
  const { t } = useTranslation();
  const { section, setSection, saveSection, hasUnsavedChanges } = useSection<MediaSection>("media");

  const saveHandler = useCallback(() => {
    saveSection({ ...section, subType: "image" });
  }, [section, saveSection]);

  return (
    <Container>
      <SubHeader
        title={t("pages.editor.media.image.header.title")}
        crumbs={[{ label: t("pages.editor.preview.footer.actions.sections"), to: "/editor/sections" }]}
        hasUnsavedChanges={hasUnsavedChanges}
      />
      <SectionHelp message={t("pages.editor.media.image.help.message")} />
      <Form>
        <Box borderBottom>
          <FormGroup>
            <Input
              type="text"
              id="title"
              value={section.pageTitle}
              onChange={e =>
                setSection({
                  ...section,
                  pageTitle: e.target.value,
                })
              }
              label={t("pages.editor.media.image.form.title")}
            />
          </FormGroup>
          <FormGroup>
            <ImageField
              shape="free"
              crop={{ ...LANDSCAPE_CROP, cropMode: "free" }}
              title={t("components.imageField.title")}
              hint={t("components.imageField.hints.free")}
              required
              image={section.image}
              onChange={(image, cropResult) =>
                setSection({
                  ...section,
                  image,
                  imageDisplayMode: cropResult?.displayMode,
                  imageAspectRatio: cropResult?.aspectRatio,
                })
              }
            />
          </FormGroup>
        </Box>
        <SaveBar onSave={saveHandler} disabled={!section.image} hasUnsavedChanges={hasUnsavedChanges} />
      </Form>
    </Container>
  );
};
